import moment from 'moment';
import groupBy from 'lodash/groupBy';
import orderBy from 'lodash/orderBy';
import cloneDeep from 'lodash/cloneDeep';
import last from 'lodash/last';
import isNull from 'lodash/isNull';

import { enum as statuses } from '../../../../../../enums/thread-statuses';

export const prepareTicketsList = (state, type) => {
	const { ticketsList: { rows } } = state[`${type}Item`].data;
	const { table: { view } } = state[`${type}List`];

	const { routing: { locationBeforeTransitions: { query } } } = state;

	const tableView = query.tableView || view;

	const shouldGroupByType = tableView === 'group';

	const prepareRowFn = rows => {
		const groupingByDate = groupBy(rows, entity => moment(entity['updated_at']).format('YYYY-MM-DD'));
		const transform = Object.keys(groupingByDate).map(date => ({
			date,
			tickets: orderBy(groupingByDate[date], row => moment(row['updated_at']).valueOf(), 'desc')
		}));
		return orderBy(transform, row => moment(row.date).valueOf(), 'desc');
	};

	const preparedRows = shouldGroupByType ?
		(groupRowsByType(rows, type)).map(entity => {
			const cloned = cloneDeep(entity);
			cloned.data = prepareRowFn(cloned.data);
			return cloned;
		}) : prepareRowFn(rows);

	return {
		type: tableView,
		rows: preparedRows
	};
};

const isWithoutAnswer = (row, type) => {
	return type != 'extThreads'
		? row.status !== statuses.paused && (
			isNull(row.last_answer) || (!isNull(row.last_answer) && !isNull(row.last_affiliate_post) &&
				moment(row.last_answer.created_at).isBefore(row.last_affiliate_post.created_at))
		)
		: !last(row.posts).admin_id;
};

export const groupRowsByType = (rows, type) => {
	const res = [
		{ name: 'unanswered', data: [], className: 'without-answer' },
		{ name: 'in work', data: [], className: 'in-work' }
	];

	rows.forEach(row => {
		if (isWithoutAnswer(row, type)) {
			res[0]['data'].push(row);
		} else {
			res[1]['data'].push(row);
		}
	});

	return res;
};



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/shared/thread-utils/index.js